import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'antd/lib/modal';
import Alert from 'antd/lib/alert';

import { withdrawLoanActions, fetchLoansActions } from '../../features/loans/ducks';
import { apiCallIds } from '../../features/loans/api';
import { selectIsInProgress } from '../../features/spinner/ducks';

const WITHDRAWAL_MODAL_TEXT =
  'Naozaj si prajete odstúpiť od Rámcovej zmluvy? Po potvrdení bude vaša žiadosť o pôžičku zrušená pred čerpaním a odošleme vám potvrdenie e-mailom.';

const WITHDRAWAL_MODAL_TITLE = 'Odstúpenie od Rámcovej zmluvy';

const ERROR_WINDOW_EXPIRED =
  'Lehota na odstúpenie od Rámcovej zmluvy už uplynula. Odstúpenie nie je možné.';

const ERROR_ALREADY_DRAWN =
  'Pôžička bola medzitým čerpaná alebo už bol vykonaný iný finančný pohyb. Odstúpenie nie je možné.';

const ERROR_GENERIC =
  'Počas spracovania žiadosti nastala chyba. Skúste to prosím neskôr.';

const mapStateToProps = state => ({
  isLoading: selectIsInProgress(state, apiCallIds.WITHDRAW_LOAN),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      withdrawLoan: withdrawLoanActions.request,
      fetchLoans: fetchLoansActions.request,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class WithdrawalModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    loan: PropTypes.object.isRequired,
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  state = {
    errorMessage: null,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible && !this.props.visible) {
      this.setState({ errorMessage: null });
    }
  }

  handleConfirm = () => {
    const { loan, actions, onCancel } = this.props;
    this.setState({ errorMessage: null });

    actions.withdrawLoan({
      loanId: loan.id,
      onSuccess: () => {
        actions.fetchLoans({ append: false, options: {} });
        onCancel();
      },
      onError: (statusCode) => {
        if (statusCode === 403) {
          this.setState({ errorMessage: ERROR_WINDOW_EXPIRED });
        } else if (statusCode === 409) {
          this.setState({ errorMessage: ERROR_ALREADY_DRAWN });
        } else {
          this.setState({ errorMessage: ERROR_GENERIC });
        }
      },
    });
  };

  render() {
    const { visible, onCancel, isLoading, t } = this.props;
    const { errorMessage } = this.state;

    return (
      <Modal
        title={t(WITHDRAWAL_MODAL_TITLE)}
        visible={visible}
        confirmLoading={isLoading}
        onOk={this.handleConfirm}
        onCancel={onCancel}
        okText={t('Odstúpiť od zmluvy')}
        cancelText={t('Zrušiť')}
        okType="danger"
      >
        <p>{t(WITHDRAWAL_MODAL_TEXT)}</p>
        {errorMessage && (
          <Alert
            message={t(errorMessage)}
            type="error"
            style={{ marginTop: 12 }}
          />
        )}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/WithdrawalModal.js